import { useEffect, useState } from "react"

const Footer = () => {
    const [barHeight, setBarHeight] = useState<number>(0)

    useEffect(() => {
        setBarHeight(() => Math.floor(window.innerHeight*0.8))
    }, [])

    return(
        <div className="h-screen md:h-auto flex flex-col">
            <div className="w-full flex-1 md:h-auto rounded-t-xl dark:bg-white bg-black dark:text-black text-white text-xl md:text-5xl lg:text-7xl xl:text-9xl md:p-12 xl:p-16 flex font-medium">
                <div className="p-4 md:p-0">
                    <span>WHERE <br/> FOURTY <br/> IS STILL <br/> WRITTEN <br/> AS IT <br/> SHOULD <br/> BE.</span>
                </div>
            </div>
                <div className="flex md:hidden justify-between flex-1">
                    <div className={`dark:bg-white bg-black w-[10%] h-full`} ></div>
                    <div className={`dark:bg-white bg-black w-[10%] h-full`} ></div>
                </div>
                <div className="w-full flex-1 dark:bg-white bg-black text-2xl md:text-3xl lg:text-5xl xl:text-7xl dark:text-black text-white text-center font-medium md:py-16 uppercase" id="contact">
                    <a href="mailto:hello@archive42.at" className="h-full w-full flex justify-center items-center hover:underline hover:cursor-cur_hover active:cursor-fancyactive_b">
                        hello@archive42.at
                    </a>
                </div>
                <div className="md:flex hidden justify-between">
                    <div className={`dark:bg-white bg-black w-[10%]`} style={{height: barHeight, maxHeight: Math.floor(window.innerWidth)}}></div>
                    <div className={`dark:bg-white bg-black w-[10%]`} style={{height: barHeight, maxHeight: Math.floor(window.innerWidth)}}></div>
                </div>
            <div className="hidden md:flex w-full h-28 dark:bg-white bg-black">

            </div>
        </div>
    )
}

export default Footer